var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55245 2.32402H8V0.0980208C7.29913 0.0317638 6.59492 -0.000947996 5.89028 2.09048e-05C3.79596 2.09048e-05 2.36381 1.16202 2.36381 3.29002V5.12401H0V7.61601H2.36381V14H5.19731V7.61601H7.55342L7.9076 5.12401H5.19731V3.53502C5.19731 2.80002 5.4129 2.32402 6.55245 2.32402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.574b869920b28fae38ff4d9775bad43d.svg";
export { ForwardRef as ReactComponent };